import Ripple from './Ripple';
export default Ripple;



// WEBPACK FOOTER //
// ./src/components/ripple/index.js